import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import {
  GetArtists,
  RestoreDeactivatedArtistSuccess,
} from '../action-creators';
import { RESTORE_DEACTIVATED_ARTIST_SUCCESS } from '../actions';
import { push } from 'connected-react-router';

export const restoreDeactivatedArtistSuccessEpic = (
  action$: Observable<Actions>
) =>
  action$.pipe(
    ofType<Actions, RestoreDeactivatedArtistSuccess>(
      RESTORE_DEACTIVATED_ARTIST_SUCCESS
    ),
    concatMap(() => {
      return [new GetArtists(), push('/label')];
    })
  );
